<template>
  <Catalogs
    title="Умения исполнителей"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkerSkillAdd'"
    :route-edit="'WorkerSkillEdit'"
    :route-view="'WorkerSkillView'"
    :route-path="'/worker_skills'"
    :can-edit="canEditCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkerSkills",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkerSkills(data);
    },
    canEditCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORKER_SKILLS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerSkills/WorkerSkills.vue